import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import { allImages } from "../../../assets";
import GlobalButton from "./../../../components/CustomButton/index";
import appcolors from "../../../constants/Colors";
import ConfirmAppointmentDialog from "./ConfirmAppointmentDialog";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing("24px"),
  },
  "& .MuiPaper-root": {
    width: "500px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing("15px 20px"),
  },
}));
let paramsData = {};

const SelectPaymentDialog = forwardRef(({ handleConfirmAppointment }, ref) => {
  const [open, setOpen] = useState(false);
  const [paymentType, setPaymentType] = useState("cash");

  useImperativeHandle(ref, () => ({
    isVisible(params) {
      paramsData = params;
      setOpen(true);
    },
    handleCloseDialog() {
      setOpen(false);
    },
  }));

  const handleClose = () => {
    setOpen(false);
  };

  const handlePaymentSelect = (type) => {
    setPaymentType(type);
  };

  return (
    <>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <IconButton
          sx={{ position: "absolute", top: "5px", right: "5px" }}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent>
          <Typography
            variant={"h1"}
            fontSize={"1.5rem"}
            fontWeight={600}
            textAlign={"center"}
          >
            Select Payment Method!
          </Typography>
          <Stack mt={3} direction={"row"} justifyContent={"center"} spacing={4}>
            <Stack
              alignItems={"center"}
              borderBottom={`4px solid ${
                paymentType === "cash" ? appcolors.primary : "transparent"
              }`}
              sx={{ cursor: "pointer" }}
              onClick={() => handlePaymentSelect("cash")}
            >
              <img
                src={allImages.cashBundleImage}
                alt={"cash-bundle-icon"}
                width={140}
              />
              <Typography variant="h6" fontWeight={500}>
                Cash
              </Typography>
            </Stack>
            <Stack
              alignItems={"center"}
              borderBottom={`4px solid ${
                paymentType === "online" ? appcolors.primary : "transparent"
              }`}
              sx={{ cursor: "pointer" }}
              onClick={() => handlePaymentSelect("online")}
            >
              <img
                src={allImages.mobileCardImage}
                alt={"mobile-card-icon"}
                width={140}
              />
              <Typography variant="h6" fontWeight={500}>
                Online
              </Typography>
            </Stack>
          </Stack>
        </DialogContent>
        <DialogActions>
          <GlobalButton
            variant={"outlined"}
            btnText={"Cancel"}
            styleProps={{ height: 40 }}
            handleClickBtn={handleClose}
          />
          <GlobalButton
            btnText={"Pay"}
            styleProps={{ height: 40 }}
            handleClickBtn={() => {
              handleClose();
              handleConfirmAppointment();
            }}
          />
        </DialogActions>
      </BootstrapDialog>
    </>
  );
});

export default SelectPaymentDialog;
